import { MediaCard, Text, VideoThumbnail } from '@shopify/polaris';
import youtube from "../../images/youtube.png";

const VideoCardDynamic = ({ description, thumbnail, title, url, showCard }) => {
    return (
        <div className={`video-wrapper${showCard ? " show-video-card" : ""}`}>
            <MediaCard
                portrait
                title={<a className='video-title' href={url} target='_blank'>{title}</a>}
            // size="small"
            // primaryAction={{
            //     content: "Watch Tutorial",
            //     url: url,
            //     external: true
            //     // onAction: () => { },
            // }}
            // description={description}
            // popoverActions={[{ content: 'Dismiss', onAction: () => { } }]}
            >
                <VideoThumbnail
                    // videoLength={80}
                    thumbnailUrl={thumbnail}
                // onClick={() => window.open(url, "_blank")}
                />
                <div className="overlay" onClick={() => window.open(url, "_blank")}>
                    <div className="play-buttonc" >
                        <img className='youtube-logo' src={youtube} alt="Youtube" />
                    </div>
                </div>
            </MediaCard>
        </div>
    )
}

export default VideoCardDynamic